import React, { HTMLAttributes, useEffect, useState } from 'react';
import { ISigningCase } from 'src/models';
import ContractingPartyStatus from '../ContractingPartyStatus';
import {
  HeaderContainer,
  SigningCaseBorder,
  SigningCaseTitle,
  StatusContainer,
  Tag,
  TitleContainer,
} from './SigningCaseHeader.styles';
import { Subtitle as CardSubtitle } from 'src/components/Card/Title';
import { getTextFromAgreementStatus } from 'src/utils/getTextFromAgreementStatus';
import { getSigningCaseHeaderColor } from 'src/utils/getSigningCaseHeaderColor';
import { useUrlParameterCheck } from 'src/utils/useUrlParameterCheck';
import { MvpAppSigningCaseHeader } from 'src/components/PortalList/PortalSigningCaseDetails/SigningCaseDetails/components';

interface Props extends HTMLAttributes<HTMLDivElement> {
  title: string;
  subTitle: string;
  status: ISigningCase['status'];
  deadline: string;
  canSign?: boolean;
}

const SigningCaseHeader = (props: Props) => {
  const { title, subTitle, status, deadline, canSign, ...rest } = props;
  const [caseStatus, setCaseStatus] = useState(status);
  const isFromMvpApp = useUrlParameterCheck('/app');

  useEffect(() => {
    setCaseStatus(status);
  }, [status]);

  return isFromMvpApp ? (
    <MvpAppSigningCaseHeader
      title={title}
      subTitle={subTitle}
      status={status}
      deadline={deadline}
      canSign={canSign}
      data-testid="mvp-signing-case-header"
    />
  ) : (
    <SigningCaseBorder status={status} {...rest}>
      <HeaderContainer>
        <Tag
          isFromMvpApp={isFromMvpApp}
          color={getSigningCaseHeaderColor(status)}
          date={deadline}
          status={status}
          data-testid="signing-case-tag"
        />
        <TitleContainer>
          <SigningCaseTitle title={title}>{title}</SigningCaseTitle>
          <CardSubtitle title={subTitle}>{subTitle}</CardSubtitle>
        </TitleContainer>
        <StatusContainer>
          <ContractingPartyStatus
            status={status}
            displayedStatusText={getTextFromAgreementStatus(caseStatus)}
          />
        </StatusContainer>
      </HeaderContainer>
    </SigningCaseBorder>
  );
};

export default SigningCaseHeader;
